/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import { Navigate, useParams } from 'react-router-dom'

import { useAuth } from '@/hooks'
import { firstAppPath } from '@/utils/appHome'

import { GeofencesView } from './GeofencesView'

/**
 * Geofences (`/geofences`, `/geofences/:geofenceId`): the company's geofences, Refresh's
 * Geofences screen rebuilt. The open geofence id lives in the route so it is deep-linkable.
 *
 * Gated on the `geofences` app grant. The routes carry no guards of their own, so the page checks
 * the same permission the nav section does; the API enforces it as well.
 */
export const GeofencesPage = () => {
  const { geofenceId } = useParams<{ geofenceId: string }>()
  const { hasPermission } = useAuth()

  if (!hasPermission('geofences')) {
    return <Navigate to={firstAppPath(hasPermission)} replace />
  }

  const id = Number(geofenceId)
  return <GeofencesView openGeofenceId={Number.isInteger(id) && id > 0 ? id : undefined} />
}

export default GeofencesPage
